import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { findByPageBiScoreList, deleteBiScoreData } from '@/api/overseasSales/businessRuleSetting'
import { useI18n } from 'vue-i18n'
import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/overseasSales'
import ButtonWrapperTips from '@/components/ButtonWrapperTips/index.vue'
const __default__ = { name: 'DcCosOFbuCustomerCodeRating' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await findByPageBiScoreList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: t('operate.r1nt24'), dataIndex: 'customerName' },
  { title: t('operate.mo6bp9'), dataIndex: 'arkCode' },
  { title: t('operate.9bijib'), dataIndex: 'score' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteBiScoreData(row.id).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosCustomerCodeRating"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: _unref(t)('operate.r1nt24')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "arkCode",
                    label: _unref(t)('operate.mo6bp9')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 0 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_cuscoderating_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_cuscoderating_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _createVNode(ButtonWrapperTips, {
                text: _unref(t)('operate.p210o8')
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'ofbu_cuscoderating_add_btn']
                  ])
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})